export const styles = {
  listItemButton: {
    py: 1.5,
    pl: 3,
    pr: 2.5,
  },
};
